import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'
import { FormElementType } from '@omnea-app/packages/universal/formBuilder/form'
import { Assert } from '@omnea-app/packages/universal/utility-types/utilityTypes'

extendZodWithOpenApi(z)

export const FormElementTypeSchema = z
  .enum([
    'address',
    'agreement',
    'purchase-order',
    'assignees',
    'bankAccountDetails',
    'catalogueBasket',
    'boolean',
    'budget',
    'checkbox',
    'contact',
    'contacts',
    'contractPeriod',
    'country',
    'countryMultiple',
    'date',
    'displayText',
    'dropdown',
    'dropdownMultiple',
    'dynamic-option',
    'files',
    'iban',
    'lineItems',
    'bankAccounts',
    'multipleChoiceCustomField',
    'multipleLinks',
    'multipleSupplierProduct',
    'number',
    'price',
    'pricing',
    'product',
    'radioGroup',
    'singleChoiceCustomField',
    'subprocessors',
    'supplierCategories',
    'supplierPortalAssignees',
    'swiftCode',
    'tags',
    'taxNumber',
    'taxNumbers',
    'text',
    'textWithConfirmationEntry',
    'user',
    'workflow',
    'agreementCancellationDate',
    'assessmentsToCancel',
    'productCatalogueAccess',
    'externalReference',
  ])
  .openapi('Shared:FormElementType')

// TESTS TO MAKE SURE THE SCHEMA ABOVE MATCHES ALL QUESTION TYPES
// TODO(COR-408): Add unit tests
type _QuestionTypeFromSchema = z.infer<typeof FormElementTypeSchema>
type _TypeTestSchemaContainsAllTypes = Assert<FormElementType, _QuestionTypeFromSchema> // 👈 Errors if the schema is missing a type
type _TypeTestSchemaDoesntContainExtraTypes = Assert<_QuestionTypeFromSchema, FormElementType> // 👈 Errors if the schema has additional types
